import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <h3>OnOneGroup</h3>
                        <p>
                            Empowering businesses with cutting-edge technology solutions and strategic investment consulting. Your trusted partner for digital transformation.
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4>Tech Services</h4>
                        <ul>
                            <li><Link to="/ai-services">AI &amp; Automation</Link></li>
                            <li><Link to="/web-development">Web Development</Link></li>
                            <li><Link to="/it-consulting">IT Consulting</Link></li>
                            <li><Link to="/software">Software Solutions</Link></li>
                            <li><Link to="/app-development">App Development</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Investment Services</h4>
                        <ul>
                            <li><Link to="/real-estate">Real Estate</Link></li>
                            <li><Link to="/investing">Investing</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Contact</h4>
                        <ul>
                            <li><a href="mailto:contact@ononegroup.com">contact@ononegroup.com</a></li>
                            <li><Link to="/contact">Get in Touch</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>© {currentYear} OnOneGroup. All rights reserved.</p>
                    <div className="social-links">
                        <a href="https://twitter.com/ononegroup" target="_blank" rel="noopener noreferrer" aria-label="X / Twitter">
                            𝕏
                        </a>
                        <a href="https://linkedin.com/company/ononegroup" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                            in
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
